<!-- <app-dealer-search>
    
    admin-users works!

</app-dealer-search> -->
<div class="admin-page">

    <h1>Utilisateurs</h1>
    <app-dynamic-table
        [items]="dealerResults"
        (updatedItemEmitter)="updateDealer($event)"
        (deletedItemEmitter)="deleteDealer($event)"
        >

    </app-dynamic-table>

</div>


